var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { display, fontSize, fontStyle, fontWeight, height, letterSpacing, lineHeight, maxHeight, maxWidth, minHeight, minWidth, overflow, space, textAlign, textStyle, width, zIndex, } from 'styled-system';
import { applyVariations, deprecatedColorValue, deprecatedPropType, getPaletteColor, textAlignAttrs, textStylesValues, typographyAttrs, } from '../utils';
export var caps = function (props) {
    if (Array.isArray(props.caps) && props.caps.length === 0) {
        return null;
    }
    return (props === null || props === void 0 ? void 0 : props.caps)
        ? {
            textTransform: 'uppercase',
        }
        : null;
};
export var regular = function (props) { return (props.regular ? { fontWeight: props.theme.regular } : null); };
export var bold = function (props) {
    if (Array.isArray(props.bold) && props.bold.length === 0) {
        return null;
    }
    return props.bold ? { fontWeight: props.theme.bold } : null;
};
export var textDecoration = function (props) {
    return props.textDecoration ? "text-decoration: ".concat(props.textDecoration, ";") : '';
};
export var textShadow = function (props) {
    var textShadowSize = props.textShadowSize || 'md';
    return props.enableTextShadow ? { textShadow: props.theme.textShadows[textShadowSize] } : null;
};
var textProps = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  color: ", ";\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  color: ", ";\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), applyVariations('Text'), getPaletteColor('base'), function (props) { return (props.bg ? "background-color: ".concat(getPaletteColor(props.bg, 'base')(props), ";") : ''); }, display, height, maxHeight, maxWidth, minHeight, minWidth, overflow, space, width, caps, regular, bold, fontSize, fontStyle, fontWeight, lineHeight, letterSpacing, textAlign, textDecoration, textShadow, textStyle, zIndex);
var textAttrs = function (props) { return (__assign(__assign({}, typographyAttrs(props)), textAlignAttrs(props))); };
var Text = styled.div.attrs(textAttrs)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), textProps);
var Span = styled.span.attrs(textAttrs)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), textProps);
var Paragraph = styled.p.attrs(textAttrs)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), textProps);
var Strike = styled.s.attrs(textAttrs)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), textProps);
Text.displayName = 'Text';
Text.propTypes = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, display.propTypes), fontSize.propTypes), fontStyle.propTypes), fontWeight.propTypes), height.propTypes), lineHeight.propTypes), maxHeight.propTypes), maxWidth.propTypes), minHeight.propTypes), minWidth.propTypes), overflow.propTypes), space.propTypes), textAlign.propTypes), textStyle.propTypes), width.propTypes), zIndex.propTypes), { align: deprecatedPropType('textAlign'), bold: PropTypes.bool, caps: PropTypes.bool, color: deprecatedColorValue(), enableTextShadow: PropTypes.bool, regular: PropTypes.bool, textDecoration: PropTypes.string, textShadowSize: PropTypes.oneOf(['sm', 'md']), textStyle: PropTypes.oneOf(textStylesValues) });
Text.span = Span;
Text.span.displayName = 'Text.span';
Text.p = Paragraph;
Text.p.displayName = 'Text.p';
Text.s = Strike;
Text.s.displayName = 'Text.s';
export default Text;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=Text.js.map